import {
  Box,
  Button,
  Divider,
  Drawer,
  MenuItem,
  Typography,
} from '@mui/material';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useMemo, useState } from 'react';
import {
  organizationsGet,
  organizationDelete,
  organizationEdit,
  checkVeeziAccess,
} from '../../api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import { Form, Formik, Field, FastField } from 'formik';
import * as Yup from 'yup';
import { CheckboxWithLabel, Select, TextField } from 'formik-mui';
import React from 'react';
import phone from 'phone';
import { useSnackbar } from 'store/store';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { useCallback } from 'react';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import ct from 'countries-and-timezones';
import { useProfile } from 'api/hooks';
import { useMedia } from 'react-use';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

export const Organizations = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const { profile } = useProfile();
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [selected, setSelected] = useState<any | null>(null);
  const snackbar = useSnackbar();
  const queryClient = useQueryClient();
  const isDarkTheme = useMedia('(prefers-color-scheme: dark)');
  const isSuperAdmin =
    profile?.roles?.some((role) => role.type === 'SUPER_ADMIN') ?? false;
  const countries = ct.getAllCountries();

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfOrganizationsResponse } = useQuery(
    'getUserAdminOfOrganizations',
    getUserAdminOfOrganizations,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfOrganizations = getUserAdminOfOrganizationsResponse!.data;

  const [selectedOrganizationId, setSelectedOrganizationId] = useState<number>(
    userAdminOfOrganizations[0]?.id,
  );
  */

  console.log('selected', selected);

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery('organizations', organizationsGet, {
    enabled: true,
    refetchOnWindowFocus: false,
  });
  const data: any = response?.data;

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation('organizationEdit', organizationEdit, {
    onError: (err: any) => {
      alert('Error', err.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries('getUserAdminOfOrganizations');
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }

    const columnDefs: ColDef[] = [
      {
        field: 'name',
        headerName: 'Name',
        sortable: true,
        flex: 1,
        minWidth: 160,
        filter: true,
      },
      {
        field: 'enabled',
        headerName: 'Enabled',
        sortable: true,
        flex: 1,
        minWidth: 70,
        cellRenderer: ({ data }) => {
          return !!data.enabled ? <DoneIcon /> : <CloseIcon />;
        },
      },
      {
        field: 'type',
        headerName: 'Type',
        sortable: true,
        flex: 1,
        minWidth: 94,
      },
      {
        field: 'createdAt',
        headerName: 'Created at',
        sortable: true,
        flex: 1,
        minWidth: 160,
        valueFormatter: ({ data }) => {
          return moment(data.createdAt).format('YYYY-MM-DD HH:mm');
        },
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  const handlePhoneChange = useCallback(
    (originalHandler) => (value) => {
      originalHandler({ target: { name: 'phone', value } });
    },
    [],
  );

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: '100vw', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit organization' : 'Add organization'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the organization.'}
              */}
              <Formik
                validateOnMount
                initialValues={
                  selected || {
                    name: '',
                    legalName: '',
                    email: '',
                    phone: '',
                    country: '',
                    type: '',
                    dataSource: '',
                    veeziAccessToken: '',
                    enabled: false,
                  }
                }
                validationSchema={Yup.object().shape({
                  name: Yup.string()
                    .min(2, 'Too short')
                    .max(50, 'Too long')
                    .required('Required'),
                  legalName: Yup.string()
                    .min(2, 'Too short')
                    .max(50, 'Too long')
                    .required('Required'),
                  email: Yup.string()
                    .email('Invalid email')
                    .required('Required'),
                  phone: Yup.string()
                    .test('phone', 'Invalid phone number', (value) => {
                      console.log('phone', value);

                      if (!value) return true;
                      return phone(value).isValid;
                    })
                    .required('Required'),
                  country: Yup.string().required('Required'),
                  type: Yup.string().required('Required'),
                  dataSource: Yup.string().when('type', (type?: string) =>
                    type === 'cinema'
                      ? Yup.string().required('Required')
                      : Yup.string().notRequired(),
                  ),
                  veeziAccessToken: Yup.string().when(
                    'dataSource',
                    (dataSource, type) =>
                      ['VEEZI_US', 'VEEZI_EU'].includes(dataSource) &&
                      type === 'cinema'
                        ? Yup.string().min(20, 'Too short').required('Required')
                        : Yup.string().notRequired(),
                  ),
                })}
                onSubmit={async ({ ...values }, { setSubmitting }) => {
                  console.log(values);

                  try {
                    if (
                      values.type === 'cinema' &&
                      (values.dataSource === 'VEEZI_US' ||
                        values.dataSource === 'VEEZI_EU')
                    ) {
                      await checkVeeziAccess({
                        veeziAccessToken: values.veeziAccessToken,
                        dataSource: values.dataSource,
                      });
                    }

                    const response = await mutateAsync({ values });

                    /*
                    if (
                      !selected &&
                      !values?.enabled &&
                      response?.status === 201
                    )
                      snackbar.open({
                        type: 'success',
                        message:
                          'Thank you for your interest. We will contact you.',
                      });
                      */
                  } catch (error: any) {
                    alert(error.error, error.message);
                    card;
                  }
                  refetch();
                  setSubmitting(false);
                  setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                      position: 'relative',
                    }}
                  >
                    <FastField
                      component={TextField}
                      label="Name"
                      name="name"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Legal name"
                      name="legalName"
                      size="small"
                    />
                    <Box className="small-formik-select-fix">
                      <FastField
                        component={Select}
                        label="Country"
                        id="country"
                        name="country"
                        size="small"
                        required
                      >
                        {!!countries &&
                          Object.keys(countries).map((c) => (
                            <MenuItem
                              key={countries[c]?.id}
                              value={countries[c]?.name}
                            >
                              {countries[c]?.name}
                            </MenuItem>
                          ))}
                      </FastField>
                    </Box>
                    <FastField
                      component={TextField}
                      label="Contact email"
                      name="email"
                      type="email"
                      size="small"
                    />
                    <MuiPhoneNumber
                      required
                      defaultCountry={'rw'}
                      name="phone"
                      label="Contact phone"
                      variant="outlined"
                      value={values.phone}
                      onBlur={handleBlur}
                      onChange={handlePhoneChange(handleChange)}
                      error={touched.phone && !!errors.phone}
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      //@ts-ignore
                      helperText={(touched.phone && errors.phone) || ''}
                      className="MuiPhoneNumber"
                      InputLabelProps={{ required: false }}
                      size="small"
                    />
                    <Box className="small-formik-select-fix">
                      <FastField
                        component={Select}
                        label="Type"
                        name="type"
                        size="small"
                      >
                        <MenuItem value={'cinema'}>Cinema</MenuItem>
                        <MenuItem value={'music'}>Music</MenuItem>
                        <MenuItem value={'festival'}>Festival</MenuItem>
                        <MenuItem value={'experience'}>Experience</MenuItem>
                        <MenuItem value={'theater'}>Theater</MenuItem>
                        <MenuItem value={'kids'}>Kids</MenuItem>
                        <MenuItem value={'exhibition'}>Exhibition</MenuItem>
                        <MenuItem value={'sport'}>Sport</MenuItem>
                        <MenuItem value={'online'}>Online</MenuItem>
                        <MenuItem value={'variety'}>Variety</MenuItem>
                      </FastField>
                    </Box>
                    <Box className="small-formik-select-fix">
                      {values.type === 'cinema' && (
                        <FastField
                          component={Select}
                          label="Data source"
                          name="dataSource"
                          size="small"
                          required
                        >
                          <MenuItem value={'LOCAL'}>Local</MenuItem>
                          <MenuItem value={'VEEZI_EU'}>Veezi EU</MenuItem>
                          <MenuItem value={'VEEZI_US'}>Veezi US</MenuItem>
                        </FastField>
                      )}
                    </Box>
                    {(values.dataSource === 'VEEZI_EU' ||
                      values.dataSource === 'VEEZI_US') &&
                      values.type === 'cinema' && (
                        <FastField
                          component={TextField}
                          label="Veezi access token"
                          name="veeziAccessToken"
                          size="small"
                        />
                      )}
                    {isSuperAdmin && (
                      <Field
                        component={CheckboxWithLabel}
                        type="checkbox"
                        name="enabled"
                        Label={{ label: 'Enabled' }}
                        size="small"
                      />
                    )}
                    <Box
                      sx={{
                        textAlign: 'right',
                        margin: '8px 0 0',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        onClick={() => {
                          setRightDrawerOpen(false);
                        }}
                        sx={{ padding: '6px 8px' }}
                      >
                        Cancel
                      </Button>
                      <Box sx={{ flex: '1 1 auto' }} />
                      {selected && (
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => {
                            setConfirmOpen(true);
                          }}
                          sx={{ padding: '6px 8px' }}
                        >
                          Delete
                        </Button>
                      )}
                      <Box sx={{ flex: '1 1 auto' }} />
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={isSubmitting || !isValid}
                        onClick={submitForm}
                        sx={{ padding: '6px 24px' }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? An owner of an organization cannot be deleted. This cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await organizationDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 0,
            alignItems: 'center',
            gap: 1,
            height: '56px',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: '1.25rem',
            }}
          >
            Organizations
          </Typography>

          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
        </Box>
        <Box
          className="ag-theme-material"
          sx={{
            background: '#000',
            borderRadius: 0,
            margin: '0 -16px -16px',
            display: 'flex',
            overflow: 'hidden',
            flexGrow: 1,
            height: '100%',
            boxShadow:
              'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px',
          }}
        >
          <AgGridReact
            className="ag-pointer-row"
            rowData={rowData}
            pagination={true}
            floatingFiltersHeight={50}
            paginationAutoPageSize={true}
            columnDefs={columnDefs}
            onRowClicked={({ data }) => {
              //navigate(`/admin/organization/${data.id}`);

              setSelected(data);
              setRightDrawerOpen(true);
            }}
          ></AgGridReact>
        </Box>
      </Box>
    </>
  );
};
